import { NormalizerState, NormalizerChannel } from 'models/normalizer';

import { PayloadAction, createSlice } from '@reduxjs/toolkit';

export const initialState: NormalizerState = {
  location: {
    tab: 'disk',
  },
  dashboard: {
    disk: {
      count: [],
      status: [],
    },
  },
  monitor: {
    selectedRow: [],
    mail: {
      mainTableRows: [],
      historyTableRows: [],
      wfHistoryTableRows: [],
    },
    disk: {
      mainTableRows: [],
      historyTableRows: [],
      wfHistoryTableRows: [],
    },
    upload: {
      mainTableRows: [],
      historyTableRows: [],
      wfHistoryTableRows: [],
    },
    eInvoice: {
      mainTableRows: [],
      historyTableRows: [],
      wfHistoryTableRows: [],
    },
    error: {
      errorRow: [],
    },
  },
};

export const slice = createSlice({
  name: 'lucyNormalizer',
  initialState,
  reducers: {
    setDefaultState: () => initialState,

    setTab: (state, { payload }: PayloadAction<NormalizerChannel>) => {
      state.location.tab = payload;
    },

    setDashboardDiskCount: (state, action) => {
      state.dashboard.disk.count = action.payload;
    },

    setDashboardDiskStatus: (state, action) => {
      state.dashboard.disk.status = action.payload;
    },

    setMonitorMailRows: (state, action) => {
      state.monitor.mail.mainTableRows = action.payload;
    },

    setMonitorMailHistory: (state, action) => {
      state.monitor.mail.historyTableRows = action.payload;
    },

    setSelectedMonitorRow: (state, action) => {
      state.monitor.selectedRow = action.payload;
    },

    setDiskMonitor: (state, action) => {
      state.monitor.disk.mainTableRows = action.payload;
    },

    setDocumentHistory: (state, action) => {
      state.monitor.disk.historyTableRows = action.payload;
    },

    setUploadMonitor: (state, action) => {
      state.monitor.upload.mainTableRows = action.payload;
    },

    setDocumentHistoryUpload: (state, action) => {
      state.monitor.upload.historyTableRows = action.payload;
    },
    setErrorRow: (state, { payload }) => {
      state.monitor.error.errorRow = payload;
    },
    setMonitorMailWfHistory: (state, action) => {
      state.monitor.mail.wfHistoryTableRows = action.payload;
    },
    setMonitorUploadWfHistory: (state, action) => {
      state.monitor.upload.wfHistoryTableRows = action.payload;
    },
    setMonitorDiskWfHistory: (state, action) => {
      state.monitor.disk.wfHistoryTableRows = action.payload;
    },
    setEInvoiceMonitor: (state, action) => {
      state.monitor.eInvoice.mainTableRows = action.payload;
    },
    setDocumentHistoryEinvoice: (state, action) => {
      state.monitor.eInvoice.historyTableRows = action.payload;
    },
    setMonitorEInvoiceWfHistory: (state, action) => {
      state.monitor.eInvoice.wfHistoryTableRows = action.payload;
    },
  },
});

export default slice.reducer;
